import { jsxs as e, jsx as l } from "react/jsx-runtime";
import { Icon as u } from "../../../../components/Icon/index.js";
import { LikeAction as m, CommentAction as y } from "../../types.js";
import { ButtonsContainer as b, LikeButtonOnActions as f, ReplyButton as k } from "./style.js";
import { useTranslation as C } from "../../../../hooks/useTranslation/index.js";
import { ReplySolid as d } from "@pelando/fontawesome/icons";
function B({
  id: o,
  liked: n,
  count: c,
  lockedComments: r,
  dispatch: i,
  className: a
}) {
  const { t } = C("common"), p = () => {
    i({
      type: n ? m.DISLIKE : m.LIKE,
      payload: { id: o }
    });
  }, s = () => {
    i({ type: y.REPLY, payload: { id: o } });
  };
  return /* @__PURE__ */ e(b, { className: a, children: [
    /* @__PURE__ */ l(
      f,
      {
        liked: n,
        count: c,
        onClick: p,
        title: t("comment-actions-like-button-title")
      }
    ),
    /* @__PURE__ */ e(
      k,
      {
        type: "button",
        onClick: s,
        "aria-hidden": r,
        title: t("comment-actions-reply-button-title"),
        children: [
          /* @__PURE__ */ l(
            u,
            {
              icon: d,
              "aria-label": t("comment-actions-reply-button-icon-aria-label")
            }
          ),
          t("comment-actions-reply-button-title")
        ]
      }
    )
  ] });
}
export {
  B as CommentActions
};
